import apiClient from './apiClient';

// We now have an 'auth' flag to determine which checks need a token
const servicesToPing = [
    { id: 'app_ui', name: 'Application UI', checkType: 'frontend', auth: false },
    { id: 'api', name: 'API Services', checkType: 'frontend', auth: false }, 
    { id: 'search', name: 'Passive Search', endpoint: 'https://candidate-matcher-prod-194126254542.us-central1.run.app/', checkType: 'backend', auth: true },
    { id: 'billing', name: 'Billing Systems', checkType: 'frontend', auth: false }, 
];

export const checkServiceStatus = async (service) => {
    try {
        if (service.checkType === 'frontend' || service.checkType === 'mock') {
            return 'Operational';
        }
        
        // Use the centralized apiClient for authenticated checks
        if (service.auth) {
            // Assuming the endpoint requires a simple authenticated GET request
            // The endpoint here is a full URL, so we can't use the standard apiClient.get
            // We'll keep the original fetch for this specific external service check.
            const { auth } = await import('../firebase/firebase');
            const token = await auth.currentUser?.getIdToken();
            if (!token) return 'Outage';

            const response = await fetch(service.endpoint, {
                method: 'GET',
                headers: { 'Authorization': `Bearer ${token}` }
            });
            return (response.ok || response.status === 403) ? 'Operational' : 'Degraded Performance';
        }
        
        // For non-auth backend checks (if any in the future), you could use apiClient
        // but for now, we only have the authenticated one.

        return 'Operational'; // Default for services not matching above criteria

    } catch (error) {
        console.error(`Status check for ${service.name} failed:`, error);
        return 'Outage';
    }
};

export const getAllServices = () => {
    return servicesToPing;
}